import type { NetworkCasseDetail, NetworkLossDetailSelectionParams } from '@gozoki/api-types'
import { keepPreviousData, type UseQueryResult, useQuery } from '@tanstack/react-query'
import { buildNetworkLossDetailQueryKey } from '../queries/network-loss-detail-params'
import { fetchNetworkCasseDetail } from '../queries/networkCasseDetail.queries'

export const useNetworkCasseDetail = (
  selection: NetworkLossDetailSelectionParams,
  enabled = true,
): UseQueryResult<NetworkCasseDetail, unknown> =>
  useQuery({
    queryKey: buildNetworkLossDetailQueryKey('get-network-casse-detail', selection),
    queryFn: () => fetchNetworkCasseDetail(selection),
    placeholderData: keepPreviousData,
    enabled,
  })
